import styled from '@emotion/styled';
import { colorPalette } from 'styles/partials/colors';

interface PageBreakWrapperProps {
  top: number;
}

export const PageBreakWrapper = styled.div<PageBreakWrapperProps>(
  {
    position: 'absolute',
    left: '-95px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    color: colorPalette.secondaryBaseGrayBlue,
  },
  props => ({
    top: `${props.top}px`,
  })
);
